import { Injectable, inject } from "@angular/core";
import { Subject } from "rxjs";
import { CreateAtgardNaturvardesbedomningCommand } from "../commands/atgard-nvb/CreateAtgardNaturvardesbedomningCommand";
import { UpdateAtgardNaturvardesbedomningCommand } from "../commands/atgard-nvb/UpdateAtgardNaturvardesbedomningCommand";
import { AtgardNaturvardesbedomningDTO } from "../models/naturvardesbedomning-models";
import { AtgardMediatorService } from "./atgard-mediator.service";
import { KontraktCommandService } from "./kontrakt-command.service";

@Injectable()
export class NvbMediatorService {
    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly kontraktCommandService = inject(KontraktCommandService);

    private readonly nvbUpdateSrc = new Subject<AtgardNaturvardesbedomningDTO>();

    get nvbUpdate$() {
        return this.nvbUpdateSrc.asObservable();
    }

    create(naturvardesomradeGuid: string) {
        const command = new CreateAtgardNaturvardesbedomningCommand(this.atgardMediatorService.atgard.guid, naturvardesomradeGuid);
        this.kontraktCommandService.update(command);
    }

    updateNvb(nvb: AtgardNaturvardesbedomningDTO) {
        const command = new UpdateAtgardNaturvardesbedomningCommand(nvb, this.atgardMediatorService.atgard.guid);
        this.kontraktCommandService.update(command);
        this.nvbUpdateSrc.next(nvb);
    }
}
